import client from './client';

export const getMySubmission = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/submissions`);
  return response.data;
};

export const updateSubmission = async (gameId, roundId, data) => {
  const response = await client.put(`/api/games/${gameId}/rounds/${roundId}/submissions`, data);
  return response.data;
};

export const submitSubmission = async (gameId, roundId) => {
  const response = await client.post(`/api/games/${gameId}/rounds/${roundId}/submissions/submit`);
  return response.data;
};

export const getAllSubmissions = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/submissions/all`);
  return response.data;
};

export const getSubmission = async (gameId, roundId, submissionId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/submissions/${submissionId}`);
  return response.data;
};

export const getContributionStatus = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/submissions/status`);
  return response.data;
};
